module.exports = {
	"Aggressive Allocation": 19,
	"China Region": 1,
	"Commodities Focused": 1,
	"Communications": 26,
	"Consumer Cyclical": 38,
	"Consumer Defensive": 16,
	"Diversified Emerging Mkts": 6,
	"Diversified Pacific/Asia": 6,
	"Energy Limited Partnership": 27,
	"Equity Energy": 52,
	"Equity Precious Metals": 29,
	"Europe Stock": 36,
	"Financial": 53,
	"Foreign Large Blend": 277,
	"Foreign Large Growth": 119,
	"Foreign Large Value": 141,
	"Foreign Small/Mid Blend": 26,
	"Foreign Small/Mid Growth": 38,
	"Foreign Small/Mid Value": 27,
	"Global Aggressive Allocation": 26,
	"Global Large-Stock Blend": 132,
	"Global Large-Stock Growth": 92,
	"Global Large-Stock Value": 60,
	"Global Moderate Allocation": 66,
	"Global Moderately Aggressive Allocation": 40,
	"Global Moderately Conservative Allocation": 1,
	"Global Real Estate": 52,
	"Global Small/Mid Stock": 61,
	"Health": 88,
	"Industrials": 46,
	"Infrastructure": 44,
	"Japan Stock": 26,
	"Large Blend": 616,
	"Large Growth": 403,
	"Large Value": 440,
	"Mid-Cap Blend": 206,
	"Mid-Cap Growth": 169,
	"Mid-Cap Value": 167,
	"Miscellaneous Allocation": 3,
	"Miscellaneous Region": 41,
	"Miscellaneous Sector": 31,
	"Moderate Allocation": 105,
	"Moderately Aggressive Allocation": 36,
	"Moderately Conservative Allocation": 2,
	"Natural Resources": 75,
	"Pacific/Asia ex-Japan Stk": 5,
	"Real Estate": 92,
	"Small Blend": 247,
	"Small Growth": 152,
	"Small Value": 165,
	"Tactical Allocation": 25,
	"Target-Date 2025": 5,
	"Target-Date 2030": 33,
	"Target-Date 2035": 40,
	"Target-Date 2040": 42,
	"Target-Date 2045": 43,
	"Target-Date 2050": 43,
	"Target-Date 2055": 42,
	"Target-Date 2060": 42,
	"Target-Date 2065+": 61,
	"Technology": 173,
	"Utilities": 26
};


//////////////////
// WEBPACK FOOTER
// ./src/data/GefScoreNormalizersPeers.json
// module id = 955
// module chunks = 0